import React, { useState, useEffect } from 'react';
import { useLocation, Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { customShowLoadingLayer,customHideLoadingLayer,showWarningLayer, hideWarningLayer,validateEmail, useFocus } from '../../utils/utils';
import NavBar from '../../components/home/navbar/navbar.component';
import FooterNew from '../../components/footernew/footernew.component';

import { ProjectActionTypes } from '../../redux/project/project.types';
import { LoginActionTypes } from '../../redux/login/login.types';
import * as actionCreators from '../../redux/login/login.actions';
import './sifremi-unuttum.styles.scss';


const API_URL = process.env.REACT_APP_API_URL; 

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

const SifremiUnuttumPage = () => {
  const xprops = useSelector(state => state);
  const dispatch = useDispatch();
  let history = useHistory();
  
  const [emailRef, setEmailFocus] = useFocus();
  const [passwordRef, setPasswordFocus] = useFocus();
  //const [loginRef, setLoginFocus] = useFocus();
  const loginFormType = "user";
  const [formType,setFormType] = useState(loginFormType);
  const [showForgetPassword, setForgetPassword] = useState(false);
  const [username,setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [lostemail,setLostemail] = useState("")


  const handleChangeUsername = (e) => setUsername(e.target.value);
  const handleChangePassword = (e) => setPassword(e.target.value);
  const handleChangeLostEmail = (e) => setLostemail(e.target.value);
  
  const handleToggleForgetPassword = () => setForgetPassword(!showForgetPassword);

  const onWarning = (payload) => {
    dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload});
  }

  const onSuccess = (loginData) => {
    dispatch({ type: LoginActionTypes.LOGIN_SUCCESS, loginData: loginData});
  }

 
  
  const logOut = () => dispatch(actionCreators.userLogout());
  const handleLogout = (event,isOpenLogin,isOpenMessage) => {
    customShowLoadingLayer();  
    onWarning({warningMessageType:'success', warningMessageText: 'Çıkış yapıldı.'});
    showWarningLayer();
    logOut();
    setTimeout(() => {
      if (isOpenMessage === true){
        dispatch(actionCreators.setChatMessageAfterLogin(true));
      }

      customHideLoadingLayer();  
      hideWarningLayer();
    },3000);
  } 

  const resetPassword = async () => {
    customShowLoadingLayer(); 
    const fmData = new FormData();
    if (lostemail !== null && validateEmail(lostemail)){
      fmData.append("email", lostemail);
      const config = {
        headers: { "content-type": "multipart/form-data" },
        crossDomain: true
      }
  
      const res = await axios.post(
        "https://www.sensizolmazsessizolmaz.org/html/do_forgetpassword.php",
        //"http://localhost/soso/new-participant-form",
        fmData,
        config
      );
      if (res.data.type === "error"){
        if (res.data.message === "DP_Session"){
          logOut();
          customHideLoadingLayer(); 
        }else if (res.data.message === "DP_Email"){
          onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen e-posta adresini kontrol edin.'});
          showWarningLayer();
          customHideLoadingLayer(); 
        }else{
          onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu. Lütfen tekrar deneyiniz.'});
          showWarningLayer();
          customHideLoadingLayer();
        }
      } else{
        if (res.data.message === "DP_Done"){
          onWarning({warningMessageType:'done', warningMessageText: 'Şifre resetleme linki e-posta adresinize gönderildi.'});
          showWarningLayer();
          customHideLoadingLayer();
        }else{
          onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu. Lütfen tekrar deneyiniz.'});
          showWarningLayer();
          customHideLoadingLayer();
        }
      }   
      


    }else{
      onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen e-posta adresini kontrol edin.'});
      customHideLoadingLayer();
      showWarningLayer();
      return false;
    }
  }  

  useEffect(() => {
    window.scrollTo(0,0);
  },[]);

  return(
    <React.Fragment>
      <div className="homeWrapper">
        <NavBar menutype="nosticky" /> 
        <div className="newSectionWrapper">
          <div className="newContentWrapper">
            <div className="loginContentWrapper">
              <div className="loginSection">
                <h4 className="login-label">E-Posta Adresi :</h4>
                <input ref={emailRef} type="text" placeholder="Lütfen e-posta adresinizi giriniz." className="edits-login" value={lostemail} onChange={handleChangeLostEmail} onKeyPress={(e)=> e.key === 'Enter' && setPasswordFocus()} />
                <p className="sifremiUnuttumWrapper"><Link className="linkForgetPassword" to="/giris">Hesabım Var.</Link></p>
                <div className="loginSectionFooter">
                  <div className="loginSectionFooterLeft">
                    Hesabınız yok mu ? <Link to='/signup' className="linkForgetPassword linkForgetPasswordSignUp">Kayıt Ol</Link>
                  </div>
                  <div className="loginSectionFooterRight">
                    <button className="btnWeb lastExpertDetailBtn btnLogin" onClick={resetPassword}>GÖNDER</button>
                  </div>                

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterNew/>
      
    </React.Fragment>
  );
}

export default SifremiUnuttumPage;